!function () {
    angular.module('DSSXAPP').factory('record', function () {
        var locals = {
            isSupportLocalStorage: function () {
                return typeof localStorage === 'object'
            },

            set: function (arg_key, arg_val) {
                this.isSupportLocalStorage() && localStorage.setItem(arg_key, arg_val)
            },

            get: function (arg_key) {
                return this.isSupportLocalStorage() ? localStorage.getItem(arg_key) : null
            },

            setObj: function (arg_key, arg_val) {
                this.set(arg_key, JSON.stringify(arg_val))
            },

            getObj: function (arg_key) {
                var res = {};
                try {
                    res = JSON.parse(this.get(arg_key))
                } catch (e) {
                    console.error("json parse error");
                }
                return res
            },

            remove: function (arg_key) {
                this.isSupportLocalStorage() && localStorage.removeItem(arg_key)
            },

            clear: function () {
                this.isSupportLocalStorage() && localStorage.clear()
            }
        };

        var itemName = "dssx-search-record";

        return {
            add: function (arg_record) {
                if (!arg_record) {
                    return;
                }

                var cur = locals.getObj(itemName);
                cur = angular.isArray(cur) ? cur : [];

                var hasRecord = false;
                var index = -1;
                angular.forEach(cur, function (e, i) {
                    if (hasRecord) {
                        return;
                    }

                    if (e === arg_record) {
                        hasRecord = true;
                        index = i;
                    }
                });

                if (hasRecord) {
                    if (index !== -1) {
                        var del = cur.splice(index, 1);
                        cur.unshift(del[0]);
                    }
                } else {
                    cur.unshift(arg_record);
                }

                locals.setObj(itemName, cur.slice(0, 8));
            },
            getAll: function () {
                return locals.getObj(itemName);
            },
            remove: function (arg_index) {
                var cur = locals.getObj(itemName);
                cur = angular.isArray(cur) ? cur : [];

                arg_index in cur && cur.splice(arg_index, 1);
                locals.setObj(itemName, cur);
            },
            removeAll: function () {
                locals.remove(itemName);
            }
        }
    });

    angular.module('DSSXAPP').component('searchHeader', {
        template:'<div class="search-header-view"><div class="sh-main" ng-class="vm.size"><div class="sh-type"><div class="sh-type-value">{{ vm.txt.product ? vm.txt.product : \'Products\'}} <i class="iconfont icon-moreunfold"></i></div></div><div class="sh-input"><input class="search-width external-controller-input-width" ng-attr-placeholder="{{vm.txt.search_placeholder ? vm.txt.search_placeholder : \'What are you looking for...\'}}" ng-model="vm.searchContent" ng-keydown="vm.searchOnEnter($event)" ng-focus="vm.showHistory = true;"><div class="sh-history" ng-show="vm.showHistory && vm.size !== \'middle\' && !vm.searchContent && vm.recordList.length"><h3>Recent Searches</h3><ul><li ng-repeat="r in vm.recordList track by $index"><a ng-href="/search.html?query={{vm.encode(r)}}">{{r}}</a> <a ng-click="vm.delete($index)">Delete</a></li><li ng-click="vm.deleteAll()">Clear History</li></ul></div></div><button class="sh-submit" ng-click="vm.search()"><i class="iconfont icon-search"></i> <span>{{ vm.txt.search ? vm.txt.search : \'Search\'}}</span></button></div></div>',
        controllerAs: 'vm',
        bindings: {
            txt: '<',
            size: '<', //可选'middle'-->国际站首页浮动，'small'-->搜索页浮动，不传为正常大小
            searchKey: '<'
        },
        controller: ['record', '$element', '$timeout', function (record, $element, $timeout) {
            this.$onChanges = bindingsOnChanges;
            var vm = this;
            var util = DSSX.util;

            vm.size = vm.size || '';
            vm.showHistory = false;
            vm.searchContent = location.href.indexOf('search.html') > -1 ? util.queryString('query') : '';
            vm.recordList = record.getAll();

            vm.search = function () {
                var result = findCN(vm.searchContent);

                if (vm.searchContent.length > 50) {
                    alert('Please input a search term less than 50 characters.');
                    return;
                }

                if (result) {
                    alert('sorry, the information you filled in is not in English. Please input the information in English instead.');
                    return;
                }

                record.add(vm.searchContent);
                vm.recordList = record.getAll();
                location.href = '/search.html?query=' + encodeURIComponent(vm.searchContent);
            };

            vm.searchOnEnter = function (event) {
                event.keyCode === 13 && vm.search();
            };

            vm.delete = function (arg_index) {
                record.remove(arg_index);
                vm.recordList = record.getAll();
            };

            vm.deleteAll = function () {
                record.removeAll();
                vm.recordList = record.getAll();
            };

            vm.encode = function (arg_str) {
                return encodeURIComponent(arg_str);
            };

            $(window).on('click', function (ev) {
                if ($element.find('.sh-input').has(ev.target).length === 0) {
                    $timeout(function () {
                        vm.showHistory = false;
                    });
                }
            });

            function bindingsOnChanges(changes) {
                if (changes.searchKey) {
                    vm.searchContent = vm.searchKey || (location.href.indexOf('search.html') > -1 ? util.queryString('query') : '');
                }
            }

            function findCN(str) { // 找到第一个连续的中文 返回数组，没找到返回 null
                var regExp = /[^a-zA-Z0-9\x21-\x2f\x3a-\x40\x5b-\x60\x7B-\x7F\s]+/;
                return str.match(regExp);
            }
        }]
    });
}();
